import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  wrapper: {
    paddingBottom: 24
  }
}))
